export default __webpack_public_path__ + "static/media/sentrobuild_light.5f480d28.svg";